import { useEffect, useMemo } from 'react';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Card, InlineNotification } from '../../../../components';
import {
  AuthErrorResponseCode,
  AuthErrorResponseCodeToDescriptionMap,
} from '../../../../common/types/auth-error-response';
import styles from './GeneralError.module.css';

export const GeneralError = () => {
  const { t } = useTranslation();
  const errorMessage = t('form.socketError.INTERNAL_ERROR.text');

  useEffect(() => {
    const sr = document.querySelector('output.screenreader-text');
    if (sr) sr.innerHTML = errorMessage;
  }, [errorMessage]);

  const redirectHref = useMemo(() => {
    const qs = new URLSearchParams(window.location.search);
    const ru = qs.get('redirect_uri');
    const state = qs.get('state') ?? '';
    const error = qs.get('error') ?? AuthErrorResponseCode.FAILURE_GENERAL;
    const errorDescription =
      qs.get('error_description') ?? AuthErrorResponseCodeToDescriptionMap[AuthErrorResponseCode.FAILURE_GENERAL];

    if (!ru) return '/login/';

    const url = new URL(ru);
    url.searchParams.set('state', state);
    url.searchParams.set('error', error);
    url.searchParams.set('error_description', errorDescription);
    return url.toString();
  }, []);

  return (
    <div data-testid="generalError">
      <Card>
        <main className={styles.main}>
          <Stack
            className={styles.errorContainerInner}
            direction="column"
            sx={{
              alignItems: 'center',
              justifyContent: 'center',
              gap: '2rem'
            }}>
            <InlineNotification appearance="error">
              <span>{errorMessage}</span>
            </InlineNotification>
            <a href={redirectHref} className={styles.backLink} data-testid="sessionCancelLink">
              {t('form.main.backToServiceProvider')}
            </a>
          </Stack>
        </main>
      </Card>
    </div>
  );
};
